module.exports = __webpack_public_path__ + "img/Laila Albalkhi.b17fc438.jpg";